import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ShortformContentPage from './pages/ShortformContentPage';
import ClinicalProductionPage from './pages/ClinicalProductionPage';
import DistributionPage from './pages/DistributionPage';
import CasesPage from './pages/CasesPage';
import CaseDetailPage from './pages/CaseDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ForbiddenPage from './pages/ForbiddenPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ydelser" element={<ServicesPage />} />
            <Route path="/ydelser/shortform-content" element={<ShortformContentPage />} />
            <Route path="/shortform-content" element={<ShortformContentPage />} />
            <Route path="/ydelser/klinisk-videoproduktion" element={<ClinicalProductionPage />} />
            <Route path="/klinisk-videoproduktion" element={<ClinicalProductionPage />} />
            <Route path="/ydelser/distribution-og-synlighed" element={<DistributionPage />} />
            <Route path="/ydelser/distribution-og-vaekst" element={<DistributionPage />} />
            <Route path="/distribution-og-synlighed" element={<DistributionPage />} />
            <Route path="/cases" element={<CasesPage />} />
            <Route path="/cases/:slug" element={<CaseDetailPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}
